<script>
    import { onDestroy } from "svelte";
    import NotificationModal from "../../../Components/Common/NotificationModal.svelte";
    import {
        SvelteTable,
        LoadingModal,
        CardLayout,
        Loader,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";
    import { addIcon } from "../../../Utils/utilConstants.svelte";

    import {
        getFormatDateAndTime,
        getText,
        turnOnEncounterNotification,
        showError,
        showException,
        showInfo,
        getCommsStatusText,
        handleDownloadPDF,
        runWithCommunicationsCheck

    } from "../../../Utils/utilFunctions.svelte";

    import CreateNotificationModal from "./CreateNotificationModal.svelte";

    export let patientEncounterDetails = {};
    export let emailNotifications = [];
    export let reloadCommunication = () => {};
    export let isInDoctor = false,
        commsDoctorId;
    export let scrollableContainerRef;

    let isResendingEmail = false,
        showResendEmailFinishModal = false,
        isShowAddNotificationModal = false,
        notificationObj = {},
        isCreatingNotification = false,
        isNoteModalOpen = false;

    let showEmailModal = false,
        emailDetails = {};

    let showResendFailModal = false,
        currentComm,
        isCancellingComm = false,
        isCancelCommModalOpen = false,
        isSendingNow = false,
        isSendNowModalOpen = false;

    let intersectionObserver,
        loadMoreIconRef,
        loadMoreIndex = 0,
        isLoadingMore = false,
        showLoadMoreIcon = true;

    const btnOptions = [
        {
            iconName: "addIcon",
            iFont: addIcon,
            iconFunction: () => _openCreateNotificationModal(),
            hasTooltip: false,
            btnText: "Compose",
        },
    ];

    const columns = [
        {
            key: "dateToSend",
            title: "Date to Send",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left pl-3 cursor-pointer w-[10%]",
            value: (v) => _getFormatDate(v.dateToSend),
        },
        {
            key: "to",
            title: "To",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-pointer w-[10%]",
            renderValue: (v) => getText(v.toName),
        },
        {
            key: "toEmail",
            title: "Email Address",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left pl-3 cursor-pointer w-[15%]",
            renderValue: (v) => getText(v.toEmail),
        },
        {
            key: "subject",
            title: "Subject",
            headerClass: "text-left pl-3 cursor-default w-[30%]",
            class: "text-left pl-3 cursor-pointer w-[30%]",
            renderValue: (v) => getText(v.subject),
        },
        {
            key: "status",
            title: "Status",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-pointer w-[10%]",
            renderValue: (v) => getCommsStatusText(v.status),
        },
        {
            key: "viewed",
            title: "Viewed By Recipient At",
            headerClass: "text-left pr-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-pointer w-[10%]",
            renderValue: (v) =>
                v.openedDate ? getFormatDateAndTime(v.openedDate) : "-",
        },
    ];

    const actionColumn = {
        key: "actions",
        title: "Actions",
        headerClass: "text-left pl-3 cursor-default w-[5%] rounded-tr-xl",
        class: "text-left px-3 cursor-pointer w-[5%]",
        renderValue: (v) => _renderActionIcons(v),
    };

    $: if (loadMoreIconRef && scrollableContainerRef) {
        intersectionObserver = new IntersectionObserver(handleIntersect, {
            threshold: 0,
            root: scrollableContainerRef,
        });
        intersectionObserver.observe(loadMoreIconRef);
    }

    onDestroy(() => {
        if (intersectionObserver) intersectionObserver.disconnect();
    });

    const handleClickCell = async ({target: {className}}, rowData, key) => {
        if (key === "actions") {
            if (className.includes("sendIcon")) await reSendEmail(rowData);
            if (className.includes("cancelIcon")) askCancelEmail(rowData);
            if (className.includes("sendNowIcon")) askSendNow(rowData);
        } else {
            await apiMethods.getMethod
                .getEncounterCommunication(patientEncounterDetails.id, rowData.id)
                .then((res) => {
                    viewEmailDetails(res);
                })
                .catch((err) => showException(err));
        }
    };

    const _handleClickPdfDownload = (data) => {
        if(data.content !== undefined && data.content !== null ) {
            handleDownloadPDF(data.content, data.name, true)
        }
    }

    const askCancelEmail = (data) => {
        if (!data.id) return;
        currentComm = data;
        isCancelCommModalOpen = true;
    };

    const cancelCurrentComm = async () => {
        if (!currentComm.id) return;

        isCancellingComm = true;

        await apiMethods.postMethod
            .cancelEncounterCommunication({
                patientEncounterId: currentComm.patientEncounterId,
                emailId: currentComm.id,
            })
            .then((res) => {
                if (res === true) {
                    showInfo("Email Cancelled");
                    reloadCommunication(loadMoreIndex);
                    loadMoreIndex = 0;
                    closeCancelCommModal();
                }
            })
            .catch((err) => showException(err));

        isCancellingComm = false;
    };

    const closeCancelCommModal = () => {
        currentComm = undefined;
        isCancelCommModalOpen = false;
    };

    const askSendNow = (data) => {
        if (!data.id) return;
        currentComm = data;
        isSendNowModalOpen = true;
    };

    const sendCommsNow = async () => {
        runWithCommunicationsCheck(patientEncounterDetails, async () => {
            if (!currentComm.id) return;

            isSendingNow = true;

            await apiMethods.postMethod
                .sendEncounterCommunicationNow({
                    patientEncounterId: currentComm.patientEncounterId,
                    emailId: currentComm.id,
                })
                .then((res) => {
                    if (res === true) {
                        showInfo("Email Sent to Patient");
                        reloadCommunication(loadMoreIndex);
                        loadMoreIndex = 0;
                        closeSendNowModal();
                    }
                })
                .catch((err) => showException(err));

            isSendingNow = false;
        })
       
    };

    const closeSendNowModal = () => {
        currentComm = undefined;
        isSendNowModalOpen = false;
    };

    const viewEmailDetails = (email) => {
        emailDetails = email;
        showEmailModal = true;
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    const createNotification = () => {
        if (isInDoctor) return createNotificationAction();

        runWithCommunicationsCheck(patientEncounterDetails, createNotificationAction);
    };

    const enableComAndCreateNote = async () => {
        isCreatingNotification = true;
        createNotificationAction();
    };

    const createNotificationAction = async () => {
        isCreatingNotification = true;

        if (isInDoctor) {
            const doctorNote = {
                ...notificationObj,
                doctorId: commsDoctorId,
            };

            await apiMethods.postMethod
                .createAccountNotification(doctorNote)
                .then((res) => _handleCreateNotification(res))
                .catch((err) => showException(err));

            _closeCreateNotificationModal();

            isCreatingNotification = false;
        } else {
            const { id, doctorId, patientId } = patientEncounterDetails;

            notificationObj = {
                ...notificationObj,
                doctorId,
                patientId,
                patientEncounterId: id,
            };

            await apiMethods.postMethod
                .createNotification("email", notificationObj)
                .then((res) => _handleCreateNotification(res))
                .catch((err) => showException(err));

            _closeCreateNotificationModal();

            isCreatingNotification = false;
        }
    };

    const reSendEmail = async (data) => {
        isResendingEmail = true;

        await apiMethods.postMethod
            .resentEncounterNotification({
                patientEncounterId: data.patientEncounterId,
                emailId: data.id,
            })
            .then((res) => _handleResendEmail(res))
            .catch((err) => showException(err));

        isResendingEmail = false;
    };

    const closeResendEmailFinishModal = () => {
        showResendEmailFinishModal = false;

        reloadCommunication(loadMoreIndex);
        loadMoreIndex = 0;
    };

    const loadMoreEmail = async () => {
        if (isLoadingMore) return;

        isLoadingMore = true;
        showLoadMoreIcon = false;

        await apiMethods.getMethod
            .getAccountNotifications(commsDoctorId, {
                "filter[notificationType]": "emails",
                start: 51 + loadMoreIndex * 25,
                limit: 25,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load more email notifications, please refresh the page and try again and contact support if the issue persists.",
                    );
                else if (
                    res.emailNotifications &&
                    !!res.emailNotifications.length
                ) {
                    showLoadMoreIcon = res.emailNotifications.length == 25;
                    loadMoreIndex++;
                    emailNotifications = [
                        ...emailNotifications,
                        ...res.emailNotifications,
                    ];
                } else showLoadMoreIcon = false;
            });

        isLoadingMore = false;
    };

    const handleIntersect = (entries) =>
        entries.forEach((entry) => {
            if (entry.isIntersecting) loadMoreEmail();
        });

    // HELPER FUNCTIONS
    const _handleCreateNotification = (res) => {
        isNoteModalOpen = false;
        const result = JSON.stringify(res);
        if (result == "true") {
            reloadCommunication(loadMoreIndex);
            loadMoreIndex = 0;
        } else
            showError(
                res.error ??
                    "Failed to create Email notification, please refresh the page and try again and contact support if the issue persists.",
            );
    };

    const _handleResendEmail = (res) => {
        const result = JSON.stringify(res);
        if (result == "true") showResendEmailFinishModal = true;
        else _openResendFailModal();
    };

    const _getFormatDate = (date) => {
        if (date == "0001-01-01T00:00:00") return "-";

        return getFormatDateAndTime(date);
    };

    const _openCreateNotificationModal = () => {
        _resetNotificationObj();
        isShowAddNotificationModal = true;
    };

    const _closeCreateNotificationModal = () => {
        _resetNotificationObj();
        isShowAddNotificationModal = false;
    };

    const _resetNotificationObj = () => {
        notificationObj = {
            subject: "",
            content: "",
        };
    };

    const _renderActionIcons = (v) => {
        return v.status === 0
            ? `<div class="flex flex-1 items-center justify-start gap-x-2"> 
                <div class="cancelIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Cancel Email">
                    <i class="cancelIcon fa fa-times"></i>
                </div>
                <div class="sendNowIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Send Email Now">
                    <i class="sendNowIcon fa fa-paper-plane"></i>
                </div>
                <div class="sendIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Resend Email">
                    <i class="sendIcon fa-solid fa-envelope"></i>
                </div>
            </div>`
            : `<div class="flex flex-1 items-center justify-end gap-x-2"> 
                <div class="sendIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Resend Email">
                    <i class="sendIcon fa-solid fa-envelope"></i>
                </div>
            </div>`;
    };

    const _openResendFailModal = () => (showResendFailModal = true);

    const _closeResendFailModal = () => (showResendFailModal = false);
</script>

<CardLayout title="Email Notifications" {btnOptions}>
    <div class="flex flex-col flex-1 w-full lg:flex-row">
        {#if emailNotifications.length}
            <div class="flex flex-col gap-y-2 w-full overflow-x-auto">
                <SvelteTable
                    columns={isInDoctor ? columns : [...columns, actionColumn]}
                    rows={emailNotifications}
                    clickCellFunc={async ({ detail: { event, row, key } }) => {
                        await handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />

                {#if isInDoctor && showLoadMoreIcon && emailNotifications.length >= 50}
                    <!-- <div
                        class={`flex flex-1 items-center justify-center py-1 ${showLoadMoreIcon && !isLoadingMore ? "" : "hidden"}`}
                        bind:this={loadMoreIconRef}
                    >
                        <Loader />
                    </div> -->
                    <div
                        class="flex flex-1 items-center justify-center py-2 gap-x-2 underline {isLoadingMore
                            ? `cursor-not-allowed`
                            : 'cursor-pointer hover:font-bold'}"
                        on:click|preventDefault={loadMoreEmail}
                    >
                        {#if isLoadingMore}
                            <Loader />
                        {/if}
                        <p>
                            {isLoadingMore ? "Loading..." : "Load More"}
                        </p>
                    </div>
                {/if}
            </div>
        {:else}
            <div
                class="flex flex-col flex-1 px-2 py-4 w-full bg-white rounded-b-2xl lg:flex-row"
            >
                <p>
                    {isInDoctor
                        ? "No Email notifications"
                        : "No Email notifications currently under this Patient encounter"}
                </p>
            </div>
        {/if}
    </div>
</CardLayout>

<CreateNotificationModal
    type="email"
    bind:notificationObj
    isModalOpen={isShowAddNotificationModal}
    {isCreatingNotification}
    closeModal={_closeCreateNotificationModal}
    {createNotification}
/>

<NotificationModal
    isModalOpen={showResendEmailFinishModal}
    showCancelBtn={false}
    submitText="Done"
    confirmAction={closeResendEmailFinishModal}
    closeModalFunction={closeResendEmailFinishModal}
>
    Email Re-sent
</NotificationModal>

{#if isResendingEmail}
    <LoadingModal titleText="Resending email..." />
{/if}

<NotificationModal
    isModalOpen={isNoteModalOpen}
    submitText="Turn on and send"
    cancelText="Save without sending"
    closeModal={createNotificationAction}
    confirmAction={enableComAndCreateNote}
    isConfirming={isCreatingNotification}
>
    Notifications is turned off for this patient.
</NotificationModal>

<NotificationModal
    isModalOpen={showEmailModal}
    submitText="OK"
    showCancelBtn={false}
    title="Email Info"
    modalMaxWidth="max-w-6xl"
    confirmAction={() => (showEmailModal = false)}
    closeModalFunction={() => (showEmailModal = false)}
    noContentPadding
>
    <div class="flex flex-col flex-1 overflow-scroll gap-y-4 p-4">
        <div class="flex flex-row w-full">
            <span class="w-32 font-semibold">Subject:</span>
            <span class="flex-1">{getText(emailDetails.subject)} </span>
        </div>
        <div class="flex flex-row w-full">
            <span class="w-32 font-semibold">Send to:</span>
            <span class="flex-1"
                >{getText(emailDetails.toName)} ({getText(
                    emailDetails.toEmail,
                )})</span
            >
        </div>
        <div class="flex flex-row w-full">
            <span class="w-32 font-semibold">Date to send:</span>
            <span class="flex-1"
                >{_getFormatDate(emailDetails.dateToSend)} ({emailDetails.sent
                    ? "SENT"
                    : "NOT SENT"})</span
            >
        </div>
        {#if emailDetails.sent}
            <div class="flex flex-row w-full">
                <span class="w-32 font-semibold">Viewed:</span>
                <span class="flex-1"
                    >{emailDetails.openedDate
                        ? getFormatDateAndTime(emailDetails.openedDate)
                        : "NOT VIEWED"}</span
                >
            </div>
        {/if}

        {#if emailDetails?.attachments?.length > 0}
            <div class="flex flex-row w-full">
                <span class="w-32 font-semibold">Attachments:</span>
                <span class="flex-1 flex flex-row gap-x-2">
                    {#each emailDetails?.attachments as emailAtt, i}
                        <p class="flex flex-row gap-x-2 bg-[#8A3ED7] attachment cursor-pointer">
                            <button
                                    id="{i}"
                                    class="break-all "
                                    on:click|preventDefault={() =>
                                    _handleClickPdfDownload(emailAtt)}
                            >
                                <i class="downloadIcon fas fa-download"></i>
                                {emailAtt.name}
                            </button>
                        </p>
                    {/each}
                </span>
            </div>
        {/if}

        <span class="w-full font-semibold">Content:</span>

        <div class="flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            <p
                class="m-2 p-2 border-solid border-2 border-natural-300 rounded-md"
            >
                {@html emailDetails.content}
            </p>
        </div>
    </div>
</NotificationModal>

<NotificationModal
    isModalOpen={showResendFailModal}
    cancelText="Close"
    closeModal={_closeResendFailModal}
    showConfirmBtn={false}
    title="Unable to resend Email"
    closeModalFunction={_closeResendFailModal}
>
    <p class="leading-6">
        Please check the encounter details and communication settings.
    </p>
    <p class="leading-6">Please contact support if the issue persists.</p>
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelCommModalOpen}
    submitText="Close"
    confirmButtonClass="btn-accent"
    cancelText="Confirm"
    confirmAction={closeCancelCommModal}
    closeModalFunction={closeCancelCommModal}
    closeModal={cancelCurrentComm}
    title="Cancel Email"
    isReverseBtns
    isConfirming={isCancellingComm}
>
    Cancel this Email?
</NotificationModal>

<NotificationModal
    isModalOpen={isSendNowModalOpen}
    submitText="Cancel"
    cancelText="Confirm"
    confirmAction={closeSendNowModal}
    closeModalFunction={closeSendNowModal}
    closeModal={sendCommsNow}
    title="Send Now"
    isReverseBtns
    isConfirming={isSendingNow}
>
    Send this email now?
</NotificationModal>


<style>
    .attachment {
        border-radius:6px;
        color: white;
        padding:3px;
        padding-left:8px;
        padding-right: 8px;
    }
</style>